import { render, staticRenderFns } from "./verticalTypeAndPice.vue?vue&type=template&id=7d3c019e&scoped=true"
import script from "./verticalTypeAndPice.vue?vue&type=script&lang=js"
export * from "./verticalTypeAndPice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3c019e",
  null
  
)

export default component.exports